import { Component, OnInit } from '@angular/core';
import { WidgetDetailInstanceService } from '../widget-detail-instance.service';
import { WidgetSunstudy } from '../../../models/widget';
import { SunstudioModalComponent } from '../../sunstudio-modal/sunstudio-modal.component';
import { SunstudyService } from '../../sunstudy.service';
import { ModalService } from '../../../core/modal.service';

@Component({
  selector: 'cw-widget-detail-sunstudies',
  templateUrl: './widget-detail-sunstudies.component.html',
  styleUrls: ['./widget-detail-sunstudies.component.scss']
})
export class WidgetDetailSunstudiesComponent implements OnInit {
  sunstudies: WidgetSunstudy[];

  constructor(private instance: WidgetDetailInstanceService,
              private sunstudyService: SunstudyService,
              private modal: ModalService) {

    this.instance.$widget.subscribe(widget => {
      if (widget) this.loadSunstudies();
    });
  }

  ngOnInit() {

  }

  showSunstudy(sunstudy: WidgetSunstudy) {
    const modalRef = this.modal.open(SunstudioModalComponent);
    modalRef.componentInstance.init(this.widget, sunstudy);
    modalRef.componentInstance.updates.subscribe(() => {
      this.loadSunstudies();
    });
  }

  deleteSunstudy(sunstudy: WidgetSunstudy) {
    if (!confirm('Ta bort solstudie?')) {
      return;
    }

    this.sunstudyService.delete(sunstudy).subscribe(() => {
      this.loadSunstudies();
    });
  }

  showCreateSunstudy() {
    const modalRef = this.modal.open(SunstudioModalComponent);
    modalRef.componentInstance.init(this.widget);
    modalRef.componentInstance.updates.subscribe(() => {
      this.loadSunstudies();
    });
  }


  get widget() {
    return this.instance.widget;
  }

  private loadSunstudies() {
    this.sunstudyService.get(this.instance.widget).subscribe(sunstudies => {
      this.sunstudies = sunstudies;
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/widgets/widget-detail/widget-detail-sunstudies/widget-detail-sunstudies.component.ts